import {
  ADD_TEST,
  ATTENDANCE_MARKED,
  FACULTY_LOGIN,
  GET_TEST,
  LOGOUT,
  MARKS_UPLOADED,
  UPDATE_FACULTY,
  UPDATE_PASSWORD,
  ADD_ONE_STUDENT,
  GET_ONE_STUDENT,
  GET_ALLL_STUDENT,
  DELETE_ONE_STUDENT,
} from "../actionTypes";

const initialState = {
  authData: null,
  updatedPassword: false,
  updatedFaculty: false,
  testAdded: false,
  marksUploaded: false,
  attendanceUploaded: false,
  tests: [],
  allStudent: [],
  students: [],
  studentDeleted: false,
};

const facultyReducer = (state = initialState, action) => {
  switch (action.type) {
    case FACULTY_LOGIN:
      localStorage.setItem("user", JSON.stringify({ ...action?.data }));
      return { ...state, authData: action?.data };
    case LOGOUT:
      localStorage.clear();
      return { ...state, authData: null };
    case UPDATE_PASSWORD:
      return {
        ...state,
        updatedPassword: action.payload,
      };
    case UPDATE_FACULTY:
      return {
        ...state,
        updatedFaculty: action.payload,
      };
    case ADD_TEST:
      return {
        ...state,
        testAdded: action.payload,
      };
    case GET_TEST:
      return {
        ...state,
        tests: action.payload,
      };
    case MARKS_UPLOADED:
      return {
        ...state,
        marksUploaded: action.payload,
      };
    case ATTENDANCE_MARKED:
      return {
        ...state,
        attendanceUploaded: action.payload,
      };
    case ADD_ONE_STUDENT:
        return {
          ...state,
          studentAdded: action.payload,
        };
    case GET_ONE_STUDENT:
          return {
            ...state,
            students: action.payload,
        };
    case GET_ALLL_STUDENT:
          return {
            ...state,
            allStudent: action.payload,
          };
    case DELETE_ONE_STUDENT:
        return {
          ...state,
          studentDeleted: action.payload,
        };
      
    default:
      return state;
  }
};

export default facultyReducer;
